
import { UserRound, AlertCircle, PoundSterling, FileText } from "lucide-react";
import { PaymentStats } from "@/hooks/usePaymentStats";

interface PaymentStatsGridProps {
  stats: PaymentStats;
}

const PaymentStatsGrid = ({ stats }: PaymentStatsGridProps) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
    }).format(amount);
  };

  const unpaidAmount = Math.max(0, (stats.totalAmount || 0) - (stats.paidAmount || 0) - (stats.estimateAmount || 0));

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
      <div className="rounded-lg border border-green-200 bg-green-50 p-5 space-y-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <PoundSterling className="h-5 w-5 text-green-600" />
            <span className="text-sm font-semibold text-green-800">Paid</span>
          </div>
          <span className="text-xs font-medium text-green-700 bg-green-100 px-2 py-0.5 rounded-full">
            {stats.paid} {stats.paid === 1 ? 'customer' : 'customers'}
          </span>
        </div>
        <p className="text-3xl font-bold text-green-700">{formatCurrency(stats.paidAmount || 0)}</p>
      </div>

      <div className="rounded-lg border border-red-200 bg-red-50 p-5 space-y-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <AlertCircle className="h-5 w-5 text-red-500" />
            <span className="text-sm font-semibold text-red-800">Unpaid</span>
          </div>
          <span className="text-xs font-medium text-red-700 bg-red-100 px-2 py-0.5 rounded-full">
            {stats.pending} {stats.pending === 1 ? 'customer' : 'customers'}
          </span>
        </div>
        <p className="text-3xl font-bold text-red-700">{formatCurrency(unpaidAmount)}</p>
      </div>

      <div className="rounded-lg border border-blue-200 bg-blue-50 p-5 space-y-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <FileText className="h-5 w-5 text-blue-600" />
            <span className="text-sm font-semibold text-blue-800">Estimates</span>
          </div>
          <span className="text-xs font-medium text-blue-700 bg-blue-100 px-2 py-0.5 rounded-full">
            {stats.estimateCount} {stats.estimateCount === 1 ? 'customer' : 'customers'}
          </span>
        </div>
        <p className="text-3xl font-bold text-blue-700">{formatCurrency(stats.estimateAmount || 0)}</p>
      </div>
    </div>
  );
};

export default PaymentStatsGrid;
